<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

<div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader && data.requestTypeInfo.requestType == 'User Profile'">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
          metadata['profileThumbImg'] !== null && metadata['profileThumbImg'] !== 'null'
            ? metadata['profileThumbImg']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle mx-auto mb-4"
      />
      <h2 class="mb-0">{{ metadata.name | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader && data.requestTypeInfo.requestType == 'User Profile'">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Address: <span>{{ metadata.addressInfo.address_line }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Gender: <span>{{ metadata.gender }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Date of birth: <span>{{ metadata.dateOfBirth | date }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data.phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          User type: <span>{{ metadata.userType }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Report category: <span>{{ data.categoryType}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Report message: <span>{{ data.message }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  
<div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader && data.requestTypeInfo.requestType == 'User Post'">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
        postData[0]['postImage'] !== null && postData[0]['postImage'] !== 'null'
            ? postData[0]['postImage']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid mb-4 img1"
      />
      <h2 class="mb-0">{{ postData[0].postTitle | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader && data.requestTypeInfo.requestType == 'User Post'">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Description: <span>{{ postData[0].postDesc }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Creator name: <span>{{ postData[0].creatorName }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>

      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Date: <span>{{ postData[0].creationTime | date }}</span>
        </div>
      </mat-list-item>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Report category: <span>{{ data.categoryType}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Report message: <span>{{ data.message }}</span>
        </div>
      </mat-list-item>
      <!-- <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          User type: <span>{{ metadata.userType }}</span>
        </div>
      </mat-list-item> -->
    </mat-list>
  </mat-dialog-content>
  <!-- ------------------------------------------------------------------------ -->



<div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader && data.status == 3">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
          metadata['profileThumbImg'] !== null && metadata['profileThumbImg'] !== 'null'
            ? metadata['profileThumbImg']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle mx-auto mb-4"
      />
      <h2 class="mb-0">{{ metadata.name | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader && data.status == 3">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Address: <span>{{ metadata.addressInfo.address_line }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Gender: <span>{{ metadata.gender }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Date of birth: <span>{{ metadata.dateOfBirth | date }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data.phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          User type: <span>{{ metadata.userType }}</span>
        </div>
      </mat-list-item>
      <!-- <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Report category: <span>{{ data.categoryType}}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          De-activation message: <span>{{ data.message }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>

  <!-- ------------------------------------------------------------------------------------------------------ -->

  <div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader && data.requestTypeInfo.requestType == 'Business Profile'">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
        businessData[0]['imageThumbUrl'] !== null && businessData[0]['imageThumbUrl'] !== 'null'
            ? businessData[0]['imageThumbUrl']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle mx-auto mb-4"
      />
      <h2 class="mb-0">{{ businessData[0].entityName | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader && data.requestTypeInfo.requestType == 'Business Profile'">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Address: <span>{{ businessData[0].addressInfo.address_line }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Owner name: <span>{{ businessData[0].ownerName }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Description: <span>{{ businessData[0].entityDesc}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data.phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >phone</mat-icon
        >
        <div mat-line>
          Phone: <span>{{ businessData[0].entityPhone }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Report category: <span>{{ data.categoryType}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Report message: <span>{{ data.message }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  